/* eslint-disable no-console */
import Layer from './Layer';

import PopupImage from '../../views/MapView/components/PopupImage';

import JpegJpgIconMapCliked from 'assets/img/jpeg-jpg-icon-map-clicked.svg';
import JpegJpgIconMap from 'assets/img/jpeg-jpg-icon-map.svg';

import JSZip from 'jszip';
/**
 * Importação da biblioteca leaflet a qual utiliza o OpenStreetMap,
 * é uma biblioteca de mapeamento leve e de codigo aberto, utiliza um banco
 * de dados geografico editável gratuito.
 */
import L from 'leaflet';

export default class GbaProject {
  /**
   * Para instanĉiar essa classe é necessário passar apenas o mapContext
   * caso queira apenas exportar, já para a importação será necessário passar
   * a instancia do arquivo que esta sendo carregado
   * @param {*} mapContext Contexto que contém os dados e métodos ativos no mapa
   * @param {*} fileContent Conteúdo de um arquivo que já foi exportado
   */
  constructor(mapContext, fileContent = null) {
    this.mapContext = mapContext;
    if (fileContent) {
      this.fileContent = fileContent;
    } else {
      this.moduleId = mapContext.activeModule.id;
      this.moduleTitle = mapContext.activeModule.titulo;
      this.activeBasemap = mapContext.basemaps.find((b) => b.active);
      this.activeBasemap = this.activeBasemap ? this.activeBasemap.id : null;
      this.centerCoordinate = mapContext.map.getCenter();
      this.zoomLevel = mapContext.map.getZoom();
      this.layers = [...mapContext.layers];
    }
  }

  /**
   * Método de transformação da layer em objeto de exportação
   * @param {Layer} layer
   */
  exportLayer = (layer) => {    
    let layerObj = {
      title: layer.getTitle(),
      type: layer.type,
      externalServiceId: layer.externalServiceId,
      visible: layer.visible,
      layerStyle: layer.layerStyle,
    };    

    if(layer.type === 'externa') {
      layerObj.url = layer.getServiceLink()
      layerObj.properties = layer.properties
      layerObj.layerStyle.opacity = layer.layerStyle.opacity
    }
    if(layer.type === 'interna') {      
      layerObj.geoserverName = layer.geoserverName;
      layerObj.geoserverWorkspace = layer.geoserverWorkspace;
      layerObj.layerStyle.opacity = layer.layerStyle.opacity;      
      layerObj.layerStyle.fillOpacity = layer.layerStyle.fillOpacity;
    }
    if (layer.type === 'importada' || layer.type === 'criada') {    
      layerObj.fileType = layer.fileType;  
      layerObj.geometryType = layer.dataType;
      layerObj.geoJson = layer.leafletLayer.toGeoJSON();      
      layerObj.layerStyle = layer.layerStyle;            

      //Verifica se existe estilização
      if(layer.classList.length > 0){
        layerObj.classList = layer.classList;
        layerObj.classColumn = layer.classColumn;
        layerObj.colorScale = layer.colorScale;
      }

      //Verifica se existe rotulo
      if(layer.selectedLabelColumn != null){
        layerObj.selectedLabelColumn = layer.selectedLabelColumn
      }

      if(layer.settingsLabel != null){
        layerObj.settingsLabel = layer.settingsLabel
      }
    }

    layer.length = new TextEncoder().encode(JSON.stringify(layerObj)).length;
    if (layer.length > 1000 && layer.length < 500000) {
      layer.length = (layer.length / 1000).toFixed(2) + 'KB';
    } else if (layer.length > 500000) {
      layer.length = (layer.length / 1000000).toFixed(2) + 'MB';
    } else {
      layer.length = layer.length.toFixed(2) + 'B';
    }
    return layerObj;
  };

  /**
   * Método de importação das layers, voltando ao seu formato original
   * @param {Layer} layer
   */
  importLayer = (layerObj) => {
    let layer = null;
    let activeModule = this.mapContext.activeModule;
    let map = this.mapContext.map;

    if(layerObj.type === 'externa'){
      //Camadas que vem de serviços e estao no catalogo
      if(layerObj.externalServiceId != null){
        layer = activeModule.camadas.camadas.find((v) => {
          if(v.externalServiceId === layerObj.externalServiceId){
            return true;
          }
          return false
        });
      }else{
        //Camadas que vem de serviços(geoserviços)
        let layerGeoservice = new Layer(
          null,
          layerObj.type,
          null,
          layerObj.properties.name,
          null,
          null,
          null,
          null,
          null
        );        
        layerGeoservice.loadDataGeoservice(layerObj.url, layerObj.properties);
        layer = layerGeoservice;
      }
      
      layer.setLayerStyleOpacity(layerObj.layerStyle.opacity)
    }

    if(layerObj.type === 'interna'){      
      //Busca a camada no catalogo interno e retorna a mesma
      layer = activeModule.camadas.camadas.find((v) => {
        if(v.geoserverName === layerObj.geoserverName && v.geoserverWorkspace === layerObj.geoserverWorkspace){
          return true;
        }          
        return false;
      });

      layer.alias = layerObj.title;     
      layer.layerStyle.opacity = layerObj.layerStyle.opacity;
      layer.layerStyle.fillOpacity = layerObj.layerStyle.fillOpacity;
      layer.setLayerStyleOpacity(layerObj.layerStyle.opacity);
      layer.setLayerStyleFillOpacity(layerObj.layerStyle.fillOpacity)
    }

    if (['importada', 'criada'].includes(layerObj.type)) {
      let customRender = L.canvas({ pane: 'mixedPane' });
      let options = {
        pane: 'mixedPane',
        style: layerObj.layerStyle,
        renderer: customRender,
      };
      if (['Point', 'MultiPoint', 'Marker', 'Text'].includes(layerObj.geometryType)) {
        options = {
          ...options,
          pointToLayer: function (feature, latlng) {
            if (layerObj.geometryType === 'Text') {              
              let markerTextArea =  L.marker(latlng, {
                pane: 'mixedPane',                  
                renderer: customRender,
                textMarker: true,
                text: feature.properties.Texto,
              });                 
              let markerTextAreaElement =  markerTextArea.pm.getElement();              
              markerTextAreaElement.classList.add('markerTextAreaGb');                           
              
              return markerTextArea;
            } else {
              var circleMarker = L.circleMarker(latlng, {           
                pane: 'mixedPane',
                ...layerObj.layerStyle,
                renderer: customRender,
              });
              if (layerObj.fileType === "jpg/jpeg" || feature?.imageUrl) {                    
                let iconDefaultJpegJpg = L.icon({
                  pane: 'mixedPane',
                  renderer: customRender,
                  iconUrl: JpegJpgIconMap,
                  iconAnchor: [9, 9],
                });
                let iconClikedJpegJpg = L.icon({
                    pane: 'mixedPane',
                    renderer: customRender,
                    iconUrl: JpegJpgIconMapCliked,
                    iconAnchor: [9, 9],
                });
                var markerJpegJpg = L.marker(latlng, {
                  pane: 'mixedPane',
                  renderer: customRender,
                  icon: iconDefaultJpegJpg                
                });
                
                markerJpegJpg.on('popupopen', function(e) {                
                  e.target.setIcon(iconClikedJpegJpg);
                  feature.popupOpen = true;
                });
                markerJpegJpg.on('popupclose', function(e) {              
                  if (map.hasLayer(e.target)) {
                    e.target.setIcon(iconDefaultJpegJpg);
                    feature.popupOpen = false;
                  }
                });
  
                let popup = L.popup({
                  autoClose: false, 
                  closeOnClick: false,
                  closeButton: false,
                  className: 'custom-leaflet-popup-jpg-jpeg-layer',              
                }).setContent(PopupImage(feature.imageUrl, markerJpegJpg));              
                markerJpegJpg.bindPopup(popup);              
  
                return markerJpegJpg;
              }
              return circleMarker;
            }
            
          },
        };
      }
    
      let geoJsonLayer = L.geoJSON(layerObj.geoJson, options);
      layer = new Layer(
        null,
        layerObj.type,
        null,
        layerObj.title,
        null,
        null,
        null,
        null,
        null
      );
      layer.setFileType(layerObj.fileType);
      layer.setLeafletLayer(geoJsonLayer);
      layer.setLayerStyle(layerObj.layerStyle);
      layer.setLayerStyleOpacity(layerObj.layerStyle.opacity);      
      layer.setLayerStyleFillOpacity(layerObj.layerStyle.fillOpacity)

      //Verifica se arquivo tem estilização
      if(layerObj.classList){
        layer.setClassList(layerObj.classList);
        layer.setClassColumn(layerObj.classColumn); 
        layer.setColorScale(layerObj.colorScale);
      }
      //Verifica se arquivo tem rotulo 
      if(layerObj.selectedLabelColumn){
        layer.setSelectedLabelColumn(layerObj.selectedLabelColumn)
      }

      if(layerObj.settingsLabel){
        layer.setSettingsLabel(layerObj.settingsLabel)
      }
    }

    if (layer) {
      layer.setVisible && layer.setVisible(layerObj.visible);
      layer.length = new TextEncoder().encode(JSON.stringify(layerObj)).length;
      if (layer.length > 1000 && layer.length < 500000) {
        layer.length = (layer.length / 1000).toFixed(2) + 'KB';
      } else if (layer.length > 500000) {
        layer.length = (layer.length / 1000000).toFixed(2) + 'MB';
      } else {
        layer.length = layer.length.toFixed(2) + 'B';
      }
    }
    
    return layer;
  };

  // Remove uma layer da lista de importação/exportação
  removeLayer = (index) => {
    this.layers = this.layers.filter((v, i) => i !== index);
  };

  // Gera o JSON que será exportado
  generateJson = () => {
    let exportJson = {
      moduleId: this.moduleId,
      moduleTitle: this.moduleTitle,
      activeBasemap: this.activeBasemap,
      centerCoordinate: this.centerCoordinate,
      zoomLevel: this.zoomLevel,
      layers: [],
    };
    this.layers.forEach((l) => {      
      let exportedLayer = this.exportLayer(l);
      if (exportedLayer) exportJson.layers.push(exportedLayer);
    });
    this.jsonContent = exportJson;
  };

  // Zipa e comprime o JSON, e disponibiliza para o usuário salvar no formato .gba (substituido .zip por .gba)
  exportToFile = () => {
    let zip = new JSZip();
    zip.file('gbaData.json', JSON.stringify(this.jsonContent));
    return zip
      .generateAsync({
        type: 'blob',
        compression: 'DEFLATE',
        compressionOptions: { level: 4 },
      })
      .then((content) => {
        let linkElement = document.createElement('a');
        linkElement.href = window.URL.createObjectURL(content);
        linkElement.download = 'Geobahia.gba';
        linkElement.click();
      });
  };

  // Realiza a extração do JSON zipado e captura as informaçãoes para serem importadas
  importFromFile = () => {
    return new Promise((resolve, reject) => {
      let fileReader = new FileReader();
      fileReader.onloadend = (e) => {
        let zip = new JSZip();
        zip
          .loadAsync(fileReader.result)
          .then((data) => {
            return data.file('gbaData.json').async('string');
          })
          .then((jsonString) => {
            let jsonContent = JSON.parse(jsonString);
            this.jsonContent = jsonContent;
            this.moduleId = jsonContent.moduleId;
            this.moduleTitle = jsonContent.moduleTitle;
            this.activeBasemap = jsonContent.activeBasemap;
            this.centerCoordinate = jsonContent.centerCoordinate;
            this.zoomLevel = jsonContent.zoomLevel;
            this.layers = [];

            jsonContent.layers.forEach((l) => {
              let importedLayer = this.importLayer(l);              
              if (importedLayer) this.layers.push(importedLayer);
            });               

            resolve();
          });
      };
      fileReader.onerror = reject;
      fileReader.readAsArrayBuffer(this.fileContent);
    });
  };

  addLayersGbaOnMap = () => { 
    let importedLayers = []; 
    // Usando reduce em vez de forEach para garantir adição sequencial de camadas
    return this.layers.reverse().reduce((previousPromise, layer) => {
      return previousPromise.then(() => {
        return this.mapContext.addLayer(layer, null, false)
          .then((layerAdded) => {
            return new Promise((resolve) => {
              if (layerAdded.layerStatus === 'loaded') {
                resolve(layerAdded);
              } else {
                layerAdded.addEventListener('load-layer', () => {                                 
                  resolve(layerAdded);
                });
              }
            });
          });
      }).then((result) => {
        importedLayers.push(result);
      });
    }, Promise.resolve()).then(() => {
      return importedLayers;
    });
  };

  // Aplica no mapa as informaçãoes obtidas no arquivo importado
  applyImportOnMap = async (confirmed) => {  
    if(confirmed === "replace") {
      // Removendo camadas
      this.mapContext.layers.forEach((l) => {
        l.leafletLayer.remove();
      });
      this.mapContext.setLayers([]);
    }
    // Definindo mapa base
    let baseMap = this.mapContext.basemaps.find(
      (b) => b.id === this.activeBasemap
    );
    if (baseMap || this.activeBasemap === null)
      this.mapContext.changeBaseMap(this.activeBasemap);
  
    // Enquadrando Mapa
    this.mapContext.map.flyTo(this.centerCoordinate, this.zoomLevel);    
  
    // Garante exibição das camadas do .gba no mapa
    return this.addLayersGbaOnMap() // Adiciona um retorno aqui
      
      .then((importedLayers) => {      
        this.mapContext.applyLayerOpacity();
  
        // Aplica Estilização nas feiçoes de camadas criadas/importadas        
        importedLayers.forEach((layer, i) => {          
          if(['importada', 'criada'].includes(layer.type)){     
            //Aplica rotulo das camadas
            if(layer.selectedLabelColumn != null){              
              // foi necessário aplicar um timeout para que o rotulo seja aplicado corretamente ao tempo do zoom do mapa
              setTimeout(() => {
                layer.addLabel(layer, layer.selectedLabelColumn.label)
              }
              , 4000);
            }
            //Aplica estilização individual das camadas 
            if(layer.classList && layer.classList.length > 0){              
              layer.applyFeaturesStyle();
            }
            //Se for camada tipo "jpg/jpeg" abre os 
            //balões popup das imagens que estavam abertos
            if (layer.fileType === "jpg/jpeg") {
              layer.leafletLayer.eachLayer(function(f) {
                if (f.feature.popupOpen) f.openPopup();
              });
            }
          }
        });
        // Move o retorno para dentro do bloco then
        return; // Retorna aqui
      });   
  };

  // Valida se o modulo atual é o mesmo do arquivo importado
  validate = () => {
    let error = null;
    if (this.moduleId !== this.mapContext.activeModule.id) {
      error = `Não foi possível importar o arquivo para ${this.mapContext.activeModule.titulo}, pois o arquivo pertence ao ${this.moduleTitle}.`;
    }
    return error ? error : true;
  };
}
